import styled from 'styled-components';

export default styled.div`
  grid-area: creator;
  align-self: center;
`;
